import { Pipe, PipeTransform } from '@angular/core';
import { RecipeTemplate } from '@pdqdev/pdq-shared/dist/entities';
import { DynamicRecipeModels } from '@pdqdev/pdq-shared/dist/interfaces';
import { IntegrationsService } from '@services/integrations/integrations.service';
import { DropdownOption } from '@storybook/components/dropdown/dropdown.component';

@Pipe({
  name: 'variablePlaceholders',
  standalone: false,
})
export class VariablePlaceholders implements PipeTransform {
  constructor() {}

  transform(str: string, variables: DynamicRecipeModels.Variable[], highlightPlaceholder?: boolean): any {
    let resStr = str;
    if (!variables) {
      return str;
    }
    variables.forEach((variable) => {
      const currentValues = IntegrationsService.getVariableValues(variable);
      const replaceVal = currentValues.length
        ? currentValues.join(', ')
        : `${Array(variable.selector.length).fill('_').join('')}`;
      resStr = resStr.replace(
        '$' + `{${variable.selector}}`,
        highlightPlaceholder ? `<b>${replaceVal}</b>` : replaceVal,
      );
    });
    return resStr;
  }
}
@Pipe({
  name: 'stringDropdownOptions',
  standalone: false,
})
export class StringDropdownOptions implements PipeTransform {
  constructor() {}

  transform(options: string[], selectedOptions: string[]): DropdownOption[] {
    if (!options) {
      return [];
    }
    return options.map((option) => {
      return {
        label: option.charAt(0).toUpperCase() + option.slice(1),
        value: option,
        checked: selectedOptions?.includes(option),
      };
    });
  }
}
@Pipe({
  name: 'sortTemplates',
  standalone: false,
})
export class SortTemplates implements PipeTransform {
  constructor() {}

  transform(recipeTemplates: RecipeTemplate[]): RecipeTemplate[] {
    return recipeTemplates.sort((a, b) => {
      if (a.dynamicPartsConfig) {
        return -1;
      } else if (b.dynamicPartsConfig) {
        return 1;
      } else return 0;
    });
  }
}
@Pipe({
  name: 'stringDropdownOption',
  standalone: false,
})
export class StringDropdownOption implements PipeTransform {
  constructor() {}

  transform(option: string): DropdownOption {
    if (option) {
      return {
        label: option.charAt(0).toUpperCase() + option.slice(1),
        value: option,
      };
    }
  }
}
